export default () => ({
  userId: '',
  authCode: '',
  email: '',
})
